import React from 'react';
import { LockIcon } from 'lucide-react';
import { checkoutUrl, offer } from '../data/offer';
import { trackPixelEvent } from '../utils/metaPixel';
interface CtaButtonProps {
  label: string;
  /** Shorter label used on phones so the button never wraps past two lines. */
  mobileLabel?: string;
  note?: string;
  size?: 'default' | 'large';
  align?: 'left' | 'center';
  fullWidth?: boolean;
  /** Where the click happened, sent to the pixel so placements can be compared. */
  placement: string;
}
export function handleCheckoutClick(placement: string): void {
  trackPixelEvent('InitiateCheckout', {
    content_name: offer.productName,
    value: offer.price,
    currency: offer.currency,
    placement
  });
}
export function CtaButton({
  label,
  mobileLabel,
  note,
  size = 'default',
  align = 'left',
  fullWidth = false,
  placement
}: CtaButtonProps) {
  const isLarge = size === 'large';
  return <div className={['flex w-full flex-col', align === 'center' ? 'items-center' : 'items-start'].join(' ')} data-id="element-67" data-mp="15ahoornrv4gc">
      <a href={checkoutUrl} rel="noopener" onClick={() => handleCheckoutClick(placement)} className={['inline-flex w-full items-center justify-center rounded-full bg-rust text-center font-semibold uppercase leading-tight tracking-[0.06em] text-white', 'shadow-lift transition-[transform,background-color] duration-150 ease-expo', 'hover:-translate-y-0.5 hover:bg-rust-dark active:translate-y-0', isLarge ? 'px-6 py-4 text-sm sm:px-9 sm:py-5 sm:text-base' : 'px-6 py-4 text-xs sm:text-sm', fullWidth ? '' : 'sm:w-auto'].join(' ')} data-id="element-68" data-mp="35z8sifjhfdf4">
        {mobileLabel ? <>
            <span className="sm:hidden" data-id="element-69" data-mp="6hj116zchgum">{mobileLabel}</span>
            <span className="hidden sm:inline" data-id="element-70" data-mp="bhnhix096bku">{label}</span>
          </> : label}
      </a>
      {note && <p className={['mt-3 flex items-start gap-1.5 text-xs font-medium leading-snug text-ink-muted', align === 'center' ? 'justify-center text-center' : ''].join(' ')} data-id="element-71" data-mp="ggqb9las8vdi">
          <LockIcon className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-72" data-mp="3hwje24k2o1cy" />
          {note}
        </p>}
    </div>;
}